module.exports = __webpack_public_path__ + "static/media/YF85_05.10337f86.jpg";